import {
    SET_LOADING,
    GET_FILTERS,
    SET_FILTER,
    GET_INDICATORS_ERROR,
    GET_INDICATORS,
    SET_PREVIOUS_FILTER,
    SET_PREVIOUS_FILTER_ERROR,
    DELETE_PREVIOUS_FILTER,
    DELETE_PREVIOUS_FILTER_ERROR,
    SET_FILTER_ERROR,
    CLEAR_PREVIOUS_FILTER,
    CLEAR_PREVIOUS_FILTER_ERROR,
    DELETE_FILTER,
    CLEAR_FILTERS,
    REFRESH_FILTERS,
    SET_START_DATE,
    END_START_DATE,
    SET_END_DATE,
    CLEAR_BASIC_FILTER,
    GET_OPK_FILTERS,
    GET_OPK_FILTERS_ERROR,
    DELETE_ALL_PREVIOUS_SUBFILTERS, DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR

} from "./actions";

export const setLoading = () => {
    return {
        type: SET_LOADING,
    };
};

function dynamicSort(property) {
    return function (a, b) {
        return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
}

export const getFilters = () => async (dispatch) => {
    try {
        setLoading();
        const res = await fetch(process.env.REACT_APP_GET_AVAILABLE_FILTERS_URL);
        let data = await res.json();
        data = data.sort(dynamicSort('id'));
        dispatch({
            type: GET_FILTERS,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_INDICATORS_ERROR,
            payload: err,
        });
    }

};

export const setFilter = (filter_id) => async (dispatch) => {
    if (typeof filter_id === 'object')
        filter_id = filter_id.id;
    try {

        dispatch({
            type: SET_FILTER,
            payload: filter_id,
        });
    } catch (err) {
        dispatch({
            type: SET_FILTER_ERROR,
            payload: err,
        });
    }

};
export const deleteFilter = (filter_id) => async (dispatch) => {

    if (typeof filter_id === 'object')
        filter_id = filter_id.id;

    dispatch({
        type: DELETE_FILTER,
        payload: filter_id,
    });

};

export const setPreviousFilter = (filter, id = "none") => async (dispatch) => {
    try {
        if (typeof filter[Object.keys(filter)[0]] !== 'object')
            filter[Object.keys(filter)[0]] = {[filter[Object.keys(filter)[0]]]: id}
    } catch (err) {
        dispatch({
            type: SET_PREVIOUS_FILTER_ERROR,
            payload: err,
        });
    }
    const payload = {
        filterName: Object.keys(filter)[0],
        filterValue: Object.values(filter)[0]
    }

    try {

        dispatch({
            type: SET_PREVIOUS_FILTER,
            payload: payload,
        });
    } catch (err) {
        dispatch({
            type: SET_PREVIOUS_FILTER_ERROR,
            payload: err,
        });
    }

};


export const deletePreviousFilter = (filter, id = "none", caller = null) => async (dispatch) => {


    console.log("delete previous filter:", filter, id, caller);
    try {
        if (typeof filter[Object.keys(filter)[0]] !== 'object')
            filter[Object.keys(filter)] = {[filter[Object.keys(filter)[0]]]: id};
    } catch (err) {
        console.log(filter[Object.keys(filter)[0]])


        console.log("delete previous filter:", filter, id, caller);
        console.error(err)


        return
    }
    const payload = {
        filterName: Object.keys(filter)[0],
        filterValue: Object.values(filter)[0]
    }
    if (Object.keys(Object.values(filter)[0])[0] === "all") {
        try {
            dispatch({
                type: DELETE_ALL_PREVIOUS_SUBFILTERS,
                payload: payload,

            });
        } catch (err) {
            dispatch({
                type: DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR,
                payload: err,
            });
        }
    } else {
        try {
            dispatch({
                type: DELETE_PREVIOUS_FILTER,
                payload: payload,

            });
        } catch (err) {
            dispatch({
                type: DELETE_PREVIOUS_FILTER_ERROR,
                payload: err,
            });
        }
    }
};

export const clearPrevious = () => async (dispatch) => {
    try {
        dispatch({
            type: CLEAR_PREVIOUS_FILTER,
        });
    } catch (err) {
        dispatch({
            type: CLEAR_PREVIOUS_FILTER_ERROR,
            payload: err,
        });
    }

};

export const clearFilters = () => async (dispatch) => {

    dispatch({
        type: CLEAR_FILTERS,
    });

};
export const refreshFilters = () => async (dispatch) => {

    dispatch({
        type: REFRESH_FILTERS,
    });

};
export const setStartDate = (date) => async (dispatch) => {

    dispatch({
        type: SET_START_DATE,
        payload: date,
    });

};
export const setEndDate = (date) => async (dispatch) => {
    dispatch({
        type: SET_END_DATE,
        payload: date,
    });

};


export const clearBasicPreviousFilter = (filter) => async (dispatch) => {


    dispatch({
        type: CLEAR_BASIC_FILTER,
        payload: filter,

    });

};


export const getOPKSFilters = (getAll) => async (dispatch) => {
    try {
        const res = await fetch(process.env.REACT_APP_OPK_LIST + "?getAll=" + getAll, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + localStorage.getItem("token")
            },
        });
        let data = await res.json();
        if (!res.ok) {
            throw res
        }
        dispatch({
            type: GET_OPK_FILTERS,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_OPK_FILTERS_ERROR,
            payload: err,
        });
    }

};